const React = require('react');
const map = require('mn-utils/map');
const delay = require('mn-utils/delay');
const filter = require('mn-utils/filter');
const LoadingItem = require('./LoadingItem');
const ReuploadItem = require('./ReuploadItem');
const Add = require('./Add');


module.exports = (props) => {
  const {
    apiRemove,
    openConfirmRemove,
    onChange,
    onLoading,
    limit,
    setState,
    files,
    buttonAtTheStart,
  } = props;
  const hasLimited = limit && limit <= files.length;
  const ComponentReuploadItem = props.componentReuploadItem || ReuploadItem;
  const ComponentAdd = props.componentAdd || Add;

  const buttonAdd = hasLimited ? null : (<ComponentAdd
    {...props}
  />);


  return (
    <>
      {buttonAtTheStart ? buttonAdd : null}
      {map(files, (item, i) => {
        const {
          id,
          fileId,
          name,
          file,
        } = item;

        function handleRemove() {
          function baseRemove() {
            delay(onLoading, 0, [false]);
            const nextFiles = filter(files, (item) => id !== item.id);
            onChange(nextFiles);
            delay(setState, 0, [{
              files: nextFiles,
            }]);
          }
          fileId && apiRemove
            ? apiRemove({
              id: fileId,
            }).then(baseRemove)
            : baseRemove();
        }

        if (!file) {
          return (
            <ComponentReuploadItem
              {...props}
              key={id}
              name={name}
              fileId={fileId}
              onRemove={() => {
                openConfirmRemove
                  ? openConfirmRemove(handleRemove)
                  : handleRemove();
              }}
            />
          );
        }

        return (
          <LoadingItem
            {...props}
            key={id}
            file={file}
            onClick={() => {
              props.onClick({fileId, id: String(i)});
            }}
            onChange={(fileId) => {
              delay(onLoading, 0, [false]);
              const nextFiles = map(files, (_file) => {
                return _file.id === id ? {
                  ..._file,
                  fileId,
                } : _file;
              });
              setState({
                files: nextFiles,
              });
              delay(onChange, 0, [nextFiles]);
            }}
            onRemove={handleRemove}
          />
        );
      })}
      {buttonAtTheStart ? null : buttonAdd}
    </>
  );
};
